var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#4ECDC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.8452 40.6318L35.2427 55.0293C47.167 51.8494 55.9998 40.9851 55.9998 28.0009C55.9998 27.7359 55.9998 27.4709 55.9998 27.2059L44.6938 16.7832L20.8452 40.6318Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0269 35.9522C28.2635 37.1888 28.2635 39.3087 27.0269 40.5452L26.1454 41.4268C24.9088 42.6634 22.7889 42.6634 21.5523 41.4268L10.3347 30.1208C9.09808 28.8842 9.09808 26.7643 10.3347 25.5277L11.2162 24.6462C12.4528 23.4096 14.5727 23.4096 15.8092 24.6462L27.0269 35.9522Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1912 16.4314C41.4278 15.1948 43.5476 15.1948 44.7842 16.4314L45.6657 17.3129C46.9023 18.5495 46.9023 20.6693 45.6657 21.9059L26.2336 41.2498C24.997 42.4864 22.8771 42.4864 21.6405 41.2498L20.759 40.3683C19.5224 39.1317 19.5224 37.0118 20.759 35.7752L40.1912 16.4314Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 27.9999,
    y1: 26.2509,
    x2: 48.9999,
    y2: 46.8134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051C2C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.c90647fc.svg";
export { ForwardRef as ReactComponent };